// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__147_b","consentsList":"PatientConsents_consentsList__2dvNH","consentsListEmpty":"PatientConsents_consentsListEmpty__2aF7l"};